import React from 'react';
import { Card, Tag } from 'antd';

function parseHardwareConfig(hardwareConfig) {
  if (!hardwareConfig) return null;
  if (typeof hardwareConfig === 'object') return hardwareConfig;
  try {
    return JSON.parse(hardwareConfig);
  } catch {
    return null;
  }
}

export default function Esp32PinMap({ hardwareConfig, fallbackChannels }) {
  const cfg = parseHardwareConfig(hardwareConfig);
  const channels = (cfg?.ioChannels && cfg.ioChannels.length)
    ? cfg.ioChannels
    : (fallbackChannels && fallbackChannels.length ? fallbackChannels : [{ name: 'led', direction: 'output', signal: 'digital', pin: 2 }]);

  const leftPins = channels.filter((_, idx) => idx % 2 === 0);
  const rightPins = channels.filter((_, idx) => idx % 2 === 1);

  const renderPin = (ch) => {
    const color = ch.direction === 'output' ? 'green' : 'blue';
    return (
      <div key={`${ch.name}-${ch.pin}`} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, padding: '4px 0', borderBottom: '1px dashed #e5e7eb' }}>
        <strong>GPIO {ch.pin}</strong>
        <span style={{ textTransform: 'capitalize' }}>{ch.name}</span>
        <Tag color={color}>{ch.direction}</Tag>
      </div>
    );
  };

  return (
    <Card size="small" bodyStyle={{ padding: 10 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 130px 1fr', gap: 10, alignItems: 'start' }}>
        <div>{leftPins.map(renderPin)}</div>
        <div style={{
          background: '#111827',
          color: '#fff',
          borderRadius: 12,
          minHeight: 180,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 10
        }}>
          <div style={{ fontWeight: 700 }}>ESP32</div>
          <div style={{ fontSize: 12, opacity: 0.9 }}>Pin Map</div>
          {cfg?.useCase && <Tag style={{ marginTop: 8 }}>{cfg.useCase}</Tag>}
          {!cfg?.useCase && <Tag style={{ marginTop: 8 }}>default</Tag>}
        </div>
        <div>{rightPins.map(renderPin)}</div>
      </div>
    </Card>
  );
}
